"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Lambdoma Triangle
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @module index.js;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

var _computeGcd = require("compute-gcd");

var _computeGcd2 = _interopRequireDefault(_computeGcd);

var _keys = require("./lib/keys");

var _keys2 = _interopRequireDefault(_keys);

var _color = require("./lib/color");

var _color2 = _interopRequireDefault(_color);

var _kalimba = require("./lib/kalimba");

var _kalimba2 = _interopRequireDefault(_kalimba);

var _sampler = require("./lib/sampler");

var _sampler2 = _interopRequireDefault(_sampler);

var _sine = require("./lib/sine");

var _sine2 = _interopRequireDefault(_sine);

var _bandpass = require("./lib/bandpass");

var _bandpass2 = _interopRequireDefault(_bandpass);

var _midi = require("./lib/midi");

var _midi2 = _interopRequireDefault(_midi);

var _oktransition = require("./vendor/oktransition");

var _oktransition2 = _interopRequireDefault(_oktransition);

var _output = require("./lib/output");

var _util = require("./lib/util");

var _scales = require("./lib/scales");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instrument = _kalimba2.default;
var organ = _sine2.default;

var grid = document.createElement("grid");
var root = 440;
var s = 50;
var w = void 0,
    h = void 0,
    ws = void 0,
    hs = void 0;

var add_on = 0;
var mul_on = 1.0;
var add_off = 0.1;
var mul_off = 0.9;

var dragging = false;
var erasing = false;
var lastNote = 0;
var notes = [];
var base_x = 0;
var base_y = 0;
var scale = _scales.scales[0];
var scaleMode = 0;
var is_split = false;
var intervals = void 0;

function build() {
  w = window.innerWidth;
  h = window.innerHeight;
  ws = Math.ceil(w / s);
  hs = Math.ceil(h / s);
  scale = _scales.scales[scaleMode % _scales.scales.length];
  if (scale.reset) {
    scale.reset(Math.round(base_x), Math.round(base_y), ws, hs);
  }
  for (var i = 0; i < ws; i++) {
    notes[i] = [];
    for (var j = 0; j < hs; j++) {
      notes[i][j] = add(i, j);
    }
  }
  log();
}
function rebuild() {
  notes.forEach(function (row) {
    return row.forEach(function (note) {
      return note.destroy();
    });
  });
  build();
}
function log() {
  var seen = {};
  // console.log(notes);
  for (var i = 0; i < 8; i++) {
    for (var j = 0; j < 8; j++) {
      var interval = notes[i][j].interval;
      var rounded = (0, _util.roundInterval)(interval);
      if (!seen[rounded] && (0, _util.intervalInRange)(interval, root)) {
        seen[rounded] = notes[i][j].interval;
      }
    }
  }
  intervals = Object.values(seen).sort(function (a, b) {
    return a - b;
  });
  // console.log(intervals);
  console.log(intervals.length, "unique intervals in 8x8");
}
function play(note) {
  if (!organ.isPlaying(note.interval)) {
    var interval = note.interval;
    // while (interval < root) {
    //   interval *= 2;
    // }
    // while (interval > root) {
    //   interval /= 2;
    // }
    var rounded = (0, _util.roundInterval)(note.interval);
    organ.play(interval);
    notes.forEach(function (row) {
      return row.forEach(function (note) {
        return note.rounded === rounded && note.div.classList.add("playing");
      });
    });
  }
}
function trigger(note) {
  if (organ === _bandpass2.default) {
    toggle(note);
    if (instrument === _kalimba2.default) {
      return;
    }
  }
  if ((0, _util.intervalInRange)(note.interval, root)) {
    instrument.play(note.interval, root);
  }
}
function trigger_index(index) {
  var interval = intervals[index];
  if (interval) {
    instrument.play(interval, root);
  }
}
function pause(note) {
  organ.pause(note.interval);
  var rounded = (0, _util.roundInterval)(note.interval);
  notes.forEach(function (row) {
    return row.forEach(function (note) {
      return note.rounded === rounded && note.div.classList.remove("playing");
    });
  });
}
function toggle(note) {
  if (organ.isPlaying(note.rounded) || note.div.classList.contains("playing")) {
    pause(note);
  } else {
    play(note);
  }
}

var modes = {
  sine: _sine2.default,
  bandpass: _bandpass2.default
};

var modus = null;
function toggleModus() {
  var intervals = void 0;
  if (modes[modus]) {
    intervals = modes[modus].getPlaying();
    modes[modus].stop();
    document.querySelector("#modus ." + modus).classList.remove("visible");
    // rebuild();
  }

  modus = modus === "sine" ? "bandpass" : "sine";
  organ = modes[modus];
  document.querySelector("#modus ." + modus).classList.add("visible");
  if (intervals) {
    intervals.forEach(function (interval) {
      return modes[modus].play(interval);
    });
  }
}

function add(i, j) {
  var ii = i + Math.round(base_x);
  var jj = j + Math.round(base_y);

  var _scale$get = scale.get(ii, jj, i, j, Math.round(base_x), Math.round(base_y)),
      _scale$get2 = _slicedToArray(_scale$get, 2),
      a = _scale$get2[0],
      b = _scale$get2[1];

  var isEqualTemperament = scale.name === "equal";

  var div = document.createElement("div");

  var interval = isEqualTemperament ? Math.pow(2, a / b) : a / b;
  // const interval = root * Math.pow(2, ((b / a) % 1) + 1);
  var add = 0;
  var frac = void 0;
  div.style.left = i * s + "px";
  div.style.top = j * s + "px";

  var note = {
    interval: interval,
    rounded: (0, _util.roundInterval)(interval, root),
    div: div,
    i: i,
    j: j,
    playing: false,
    destroy: function destroy() {
      return grid.removeChild(div);
    },
    recolor: function recolor(numerator, denominator) {
      var aa = a / numerator;
      var bb = b / denominator;
      if (aa < bb && aa !== 0) {
        add = -Math.log(bb / aa) / 3.5;
      } else {
        add = Math.log(aa / bb) / 6;
      }
      var a_inv = a * denominator;
      var b_inv = b * numerator;
      var a_disp = void 0,
          b_disp = void 0;
      if (scale.name === "hyperbolic") {
        a_inv *= Math.round(base_y) + 1;
        b_inv *= Math.round(base_y) + 1;
        var ba_gcd = (0, _computeGcd2.default)(Math.round(a_inv), Math.round(b_inv));
        a_disp = Math.round(a_inv / ba_gcd);
        b_disp = Math.round(b_inv / ba_gcd);
        // a_disp = Math.round(a_inv);
        // b_disp = Math.round(b_inv);
      } else {
        var _ba_gcd = (0, _computeGcd2.default)(a_inv, b_inv);
        a_disp = a_inv / _ba_gcd;
        b_disp = b_inv / _ba_gcd;
      }

      frac = Math.log2(isEqualTemperament ? interval : aa / bb) % 1;

      var frac_orig = Math.log2(a / b) % 1;
      if (frac < 0) {
        frac += 1;
      }

      if (frac_orig < 0) {
        frac += 1;
      }

      if (isEqualTemperament) {
        if (interval % 1 === 0) {
          div.style.fontWeight = "900";
        } else {
          div.style.fontWeight = "500";
        }
      } else {
        if (frac_orig === 0) {
          div.style.fontWeight = "900";
        } else {
          div.style.fontWeight = "500";
        }
      }

      div.innerHTML = isEqualTemperament ? "<div>" + a + "</div><div></div><div>" + b + "\u221A2</div>" : "<div>" + a_disp + "</div><div>/</div><div>" + b_disp + "</div>";

      if (note.playing) {
        div.style.backgroundColor = (0, _color2.default)(frac, add + add_on, mul_on);
      } else {
        div.style.backgroundColor = (0, _color2.default)(frac, add + add_off, mul_off);
      }

      if (organ.isPlaying(interval)) {
        div.classList.add("playing");
      }
    }
  };

  note.recolor(1, 1);

  if (_util.browser.isDesktop) {
    div.addEventListener("mousedown", function (event) {
      if (event.button === 2) {
        // rightclick
        event.preventDefault();
        // notes.forEach((row) => row.forEach((note) => note.recolor(a, b)));
        is_split = [a, b];
        toggle(note);
        return;
      }
      div.style.backgroundColor = (0, _color2.default)(frac, add + add_on, mul_on);
      dragging = true;
      trigger(note);
    });
    div.addEventListener("mouseenter", function () {
      div.style.backgroundColor = (0, _color2.default)(frac, add + add_on, mul_on);
      if (dragging) {
        trigger(note);
      }
    });
    div.addEventListener("mouseleave", function () {
      div.style.backgroundColor = (0, _color2.default)(frac, add + add_off, mul_off);
    });
    div.addEventListener("contextmenu", function (event) {
      if (!event.ctrlKey || !event.metaKey || !event.altKey) {
        event.preventDefault();
      }
    });
  } else {
    div.addEventListener("touchstart", function (e) {
      e.preventDefault();
      trigger(note);
      // erasing = !note.playing;
      dragging = true;
      lastNote = note;
    });
  }
  grid.appendChild(div);
  return note;
}

function bind() {
  if (_util.browser.isDesktop) {
    document.addEventListener("mousedown", function (event) {
      if (event.button !== 2) {
        dragging = true;
      }
    });
    document.addEventListener("mouseup", function () {
      dragging = false;
    });
  } else {
    document.addEventListener("touchstart", function (e) {
      e.preventDefault();
      dragging = true;
    });
    document.addEventListener("touchmove", function (e) {
      e.preventDefault();
      var x = Math.floor(e.touches[0].pageX / s);
      var y = Math.floor(e.touches[0].pageY / s);
      if (!(x in notes) || !(y in notes[x])) return;
      var note = notes[x][y];
      if (note !== lastNote) {
        if (dragging) {
          trigger(note);
        }
        lastNote = note;
      }
    });
    document.addEventListener("touchend", function () {
      dragging = false;
    });
  }
  window.addEventListener("resize", build);
  window.addEventListener("keydown", keydown, true);
  _keys2.default.listen(trigger_index);

  // UI
  document.querySelector("#help-button").addEventListener("click", function () {
    return document.querySelector("#help").classList.toggle("visible");
  });
  document.querySelector("#root").addEventListener("click", function () {
    return document.querySelector(".root-select").classList.toggle("visible");
  });
  document.querySelector("#modus").addEventListener("click", toggleModus);
  Array.from(document.querySelectorAll(".mode")).forEach(function (el) {
    // console.log(el.getAttribute("name"));
    el.addEventListener("click", function (event) {
      var name = el.getAttribute("name");
      scaleMode = _scales.scales.findIndex(function (scale) {
        return scale.name === name;
      });
      rebuild();
    });
  });

  toggleModus();
  bindRoot();

  // Wheel to scroll
  if (_util.browser.isDesktop) {
    grid.addEventListener("wheel", function (e) {
      var new_base_x = Math.max(0, base_x + e.deltaX / 32);
      var new_base_y = Math.max(0, base_y + e.deltaY / 32);
      if (Math.round(base_x) !== Math.round(new_base_x) || Math.round(base_y) !== Math.round(new_base_y)) {
        base_x = new_base_x;
        base_y = new_base_y;
        rebuild();
      } else {
        base_x = new_base_x;
        base_y = new_base_y;
      }
    });
  }
}

var isReset = false;
function keydown(e) {
  if (document.activeElement !== document.body) {
    return;
  }
  var step = 1;
  if (e.shiftKey) {
    step += 4;
  }
  console.log(e.keyCode);
  switch (e.keyCode) {
    case 27:
      // esc - PANIC
      if (isReset) {
        base_x = 0;
        base_y = 0;
        showMessage("reset!");
      }
      organ.stop();
      _sampler2.default.stop();
      rebuild();
      isReset = true;
      setTimeout(function () {
        return isReset = false;
      }, 500);
      break;
    case 37:
      // left
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      base_x = Math.max(0, base_x - step);
      rebuild();
      break;
    case 38:
      // up
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      base_y = Math.max(0, base_y - step);
      rebuild();
      break;
    case 39:
      // right
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      base_x += step;
      rebuild();
      break;
    case 40:
      // down
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      base_y += step;
      rebuild();
      break;
    case 220:
      // \
      _midi2.default.enable(trigger_index);
      break;
    case 192:
      // ~
      toggleModus();
      break;
    case 191:
      // ?
      document.querySelector("#help").classList.toggle("visible");
      break;
    case 189: // -
    case 173:
      // -
      e.preventDefault();
      e.stopPropagation();
      if (e.altKey || e.metaKey) {
        setRoot(root - e.shiftKey ? 10 : 1);
      } else {
        scaleMode = (0, _util.mod)(scaleMode - 1, _scales.scales.length);
        rebuild();
        showMessage(scale.name);
      }
      break;
    case 187: // =
    case 61:
      // =
      e.preventDefault();
      e.stopPropagation();
      if (e.altKey || e.metaKey) {
        setRoot(root + e.shiftKey ? 10 : 1);
      } else {
        scaleMode = (0, _util.mod)(scaleMode + 1, _scales.scales.length);
        rebuild();
        showMessage(scale.name);
      }
      break;
  }
}
function setRoot(newRoot) {
  if (!newRoot) {
    return;
  }
  root = (0, _util.clamp)(Math.round(newRoot), 1, 300000);
  _sine2.default.setRoot(root);
  _bandpass2.default.setRoot(root);
  showMessage("Root: " + Math.round(root) + " hz");
  showRoot(root);
  document.querySelector(".root-select input").value = Math.round(root);
}

function showRoot(root) {
  var el = document.querySelector("#root span");
  el.style.fontSize = root < 1000 ? "14px" : root < 10000 ? "12px" : "9px";
  el.innerHTML = Math.round(root);
}
function bindRoot() {
  document.querySelector(".root-select").addEventListener("click", function () {
    document.querySelector(".root-select").classList.remove("visible");
  }, false);
  document.querySelector(".root-select > div").addEventListener("click", function (event) {
    event.stopPropagation();
  });
  document.querySelector(".root-select input").addEventListener("input", function (event) {
    setRoot(parseFloat(event.target.value));
  });
  Object.entries({
    ok: function ok() {
      return document.querySelector(".root-select").classList.remove("visible");
    },
    "div-2": function div2() {
      return setRoot(root / 2);
    },
    "mul-2": function mul2() {
      return setRoot(root * 2);
    },
    "div-3-2": function div32() {
      return setRoot(root * 2 / 3);
    },
    "mul-3-2": function mul32() {
      return setRoot(root * 3 / 2);
    },
    "sub-10": function sub10() {
      return setRoot(root - 10);
    },
    "sub-1": function sub1() {
      return setRoot(root - 1);
    },
    "add-1": function add1() {
      return setRoot(root + 1);
    },
    "add-10": function add10() {
      return setRoot(root + 10);
    }
  }).forEach(function (_ref, index) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        fn = _ref2[1];

    var el = document.querySelector(".root-select ." + key);
    el.addEventListener("click", fn);
  });
  Object.entries({
    "note-c": function noteC() {
      return setRoot(440 * Math.pow(2, -9 / 12) * getOctave(root));
    },
    "note-db": function noteDb() {
      return setRoot(440 * Math.pow(2, -8 / 12) * getOctave(root));
    },
    "note-d": function noteD() {
      return setRoot(440 * Math.pow(2, -7 / 12) * getOctave(root));
    },
    "note-eb": function noteEb() {
      return setRoot(440 * Math.pow(2, -6 / 12) * getOctave(root));
    },
    "note-e": function noteE() {
      return setRoot(440 * Math.pow(2, -5 / 12) * getOctave(root));
    },
    "note-f": function noteF() {
      return setRoot(440 * Math.pow(2, -4 / 12) * getOctave(root));
    },
    "note-gb": function noteGb() {
      return setRoot(440 * Math.pow(2, -3 / 12) * getOctave(root));
    },
    "note-g": function noteG() {
      return setRoot(440 * Math.pow(2, -2 / 12) * getOctave(root));
    },
    "note-ab": function noteAb() {
      return setRoot(440 * Math.pow(2, -1 / 12) * getOctave(root));
    },
    "note-a": function noteA() {
      return setRoot(440 * Math.pow(2, 0 / 12) * getOctave(root));
    },
    "note-bb": function noteBb() {
      return setRoot(440 * Math.pow(2, 1 / 12) * getOctave(root));
    },
    "note-b": function noteB() {
      return setRoot(440 * Math.pow(2, 2 / 12) * getOctave(root));
    },
    "note-c2": function noteC2() {
      return setRoot(440 * Math.pow(2, 3 / 12) * getOctave(root));
    }
  }).forEach(function (_ref3, index) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        fn = _ref4[1];

    var el = document.querySelector(".root-select ." + key);
    el.addEventListener("click", fn);
    el.style.background = (0, _color2.default)(Math.pow(2, index / 12), key.length === 6 ? 0 : -0.15, key.length === 6 ? 0.95 : 0.4, 1);
  });
}

var C_ROOT = Math.round(440 * Math.pow(2, 3 / 12));
function getOctave(value) {
  var octave = 0;
  while (value < C_ROOT) {
    octave -= 1;
    value *= 2;
  }
  while (value > C_ROOT) {
    octave += 1;
    value /= 2;
  }
  return Math.pow(2, octave);
}

var messageTransition = void 0;
function showMessage(message) {
  var el = document.getElementById("message");
  el.innerHTML = message;
  el.style.opacity = 1;
  if (messageTransition) {
    messageTransition.cancel();
  }
  messageTransition = _oktransition2.default.add({
    obj: el.style,
    from: { opacity: 1 },
    to: { opacity: 0 },
    delay: 1500,
    duration: 2000,
    easing: _oktransition2.default.easing.circ_out
  });
}

(0, _util.requestAudioContext)(function () {
  var output = (0, _output.getOutput)();
  document.body.appendChild(grid);
  _kalimba2.default.load(output);
  _sine2.default.load(output);
  _bandpass2.default.load(output);
  _sampler2.default.load(output, function ready() {
    instrument = _sampler2.default;
  });
  build();
  bind();
});


//////////////////
// WEBPACK FOOTER
// ./client/index.js
// module id = 271
// module chunks = 0